import UEditor from './components/UEditor.vue';

export default UEditor;



//////////////////
// WEBPACK FOOTER
// ./~/vue-ueditor/src/index.js
// module id = 428
// module chunks = 0